export type TEAM = 'growth' | 'seller' | 'listings';

/** Name ODTeamBoundary throws under, so observability can recognize and ignore those re-raises. */
export const OD_TEAM_BOUNDARY_ERROR = 'TeamErrorBoundary';
